export default {"src":"/apac/_next/static/media/sds.a33f7d93.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};